import axios from "axios";

// Si el back responde 401 (token caducado o inválido, o usuario desactivado)
// se cierra la sesión para volver a pedir login. No se aplica a loginAzure,
// que ya avisa por su cuenta: si no, un usuario desactivado entraría en bucle.
export const installSessionInterceptor = (onUnauthorized: () => void) => {
  let handled = false;
  const id = axios.interceptors.response.use(undefined, (error) => {
    const url: string = error?.config?.url ?? "";
    if (error?.response?.status === 401 && !url.includes("/auth/loginAzure") && !handled) {
      handled = true;
      onUnauthorized();
    }
    return Promise.reject(error);
  });
  return () => axios.interceptors.response.eject(id);
};
